import React from 'react';
import { MultiSelect } from '@/components/ui/multi-select';
import { Badge } from '@/components/ui/badge';
import { X } from 'lucide-react';

export function MultiSelectFilter({ label, options, selected, onChange }) {
  const handleClear = (e) => {
    e.stopPropagation();
    onChange([]);
  };

  return (
    <div className="flex flex-col gap-1 min-w-[200px]">
      <div className="flex items-center justify-between">
        <label className="text-sm font-medium text-gray-700">{label}</label>
        {selected.length > 0 && (
          <button
            onClick={handleClear}
            className="text-xs text-gray-500 hover:text-gray-700 flex items-center gap-1"
            title="Clear filter"
          >
            <X className="h-3 w-3" />
            Clear
          </button>
        )}
      </div>
      <MultiSelect
        options={options}
        selected={selected}
        onChange={onChange}
        placeholder={label}
      />
    </div>
  );
}
